import {useRef} from 'react';
import {Pie, ImageLabels, NumberLabels} from '../libs';
import {CHART_COLORS} from '../theme';

export function dataFromEstate({dividuals}) {
  return {
    labels: dividuals.map(({name}) => name),
    datasets: [{
      data: dividuals.map(({ratio}) => ratio),
      backgroundColor: CHART_COLORS.map(({bg}) => bg ?? 'gray')
    }]
  };
}

export function pluginDataFromEstate({dividuals}) {
  const sum = dividuals.reduce((s, {ratio}) => s + ratio, 0);
  const percentages = [];
  for (let i = 0, l = dividuals.length; i < l; i++) {
    if (i === l - 1) {
      const currentSum = percentages.reduce((s, p) => s + p, 0);
      percentages.push(100 - currentSum);
    } else {
      percentages.push(Math.round(dividuals[i].ratio * 100 / sum));
    }
  }

  return {
    plugins: {
      imagelabels: {
        dividuals: dividuals.map(({name, comfort}, index) => ({
          name, comfort,
          percentage: percentages[index]
        }))
      }
    }
  };
}

export default function DividualsChart({estate, onHover}) {
  const ref = useRef(null);

  return (
    <Pie ref={ref} data={dataFromEstate(estate)} plugins={[NumberLabels]} options={{
      ...pluginDataFromEstate(estate),
      onHover: (event, elements, chart) => {
        const element = chart.getActiveElements()[0];
        onHover(element?.index);
      }
    }} />
  );
}
